import { render, staticRenderFns } from "./ActivityGoodsList.vue?vue&type=template&id=0f8710f3"
import script from "./ActivityGoodsList.vue?vue&type=script&lang=js"
export * from "./ActivityGoodsList.vue?vue&type=script&lang=js"
import style0 from "./ActivityGoodsList.vue?vue&type=style&index=0&id=0f8710f3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports